export function fa_to_eng_number(str) {
    const string = str.toString()
    const result = string.split('');
    let eng = '';

    result.forEach((letter) => {
        switch (letter) {
            case '۱':
                eng += '1';
                break;
            case '۲':
                eng += '2';
                break;
            case '۳':
                eng += '3';
                break;
            case '۴':
                eng += '4';
                break;
            case '۵':
                eng += '5';
                break;
            case '۶':
                eng += '6';
                break;
            case '۷':
                eng += '7';
                break;
            case '۸':
                eng += '8';
                break;
            case '۹':
                eng += '9';
                break;
            case '۰':
                eng += '0';
                break;
            default:
                eng += letter;
        }
    })



    return eng;
}
